import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface CultureSectionProps {
  className?: string;
}

interface CultureValue {
  id: number;
  icon: string;
  title: string;
  description: string;
}

const CultureSection = ({ className = '' }: CultureSectionProps) => {
  const cultureValues: CultureValue[] = [
    {
      id: 1,
      icon: 'SparklesIcon',
      title: 'Excellence in Delivery',
      description: 'We hold ourselves to the highest standards of professional excellence, delivering measurable results that exceed client expectations.',
    },
    {
      id: 2,
      icon: 'HeartIcon',
      title: 'Collaborative Spirit',
      description: 'We believe in the power of partnership, working closely with clients and partners to co-create solutions that drive lasting change.',
    },
    {
      id: 3,
      icon: 'AcademicCapIcon',
      title: 'Continuous Learning',
      description: 'We invest in our team\'s growth, staying at the forefront of AI transformation practices through ongoing research and development.',
    },
    {
      id: 4,
      icon: 'ShieldCheckIcon',
      title: 'Integrity & Trust',
      description: 'We build relationships based on transparency, honesty, and ethical practice, earning trust through consistent delivery.',
    },
    {
      id: 5,
      icon: 'LightBulbIcon',
      title: 'Innovation Mindset',
      description: 'We challenge conventional thinking, bringing fresh perspectives and creative solutions to complex transformation challenges.',
    },
    {
      id: 6,
      icon: 'GlobeAltIcon',
      title: 'Inclusive Approach',
      description: 'We value diverse perspectives and create environments where all voices are heard, respected, and contribute to better outcomes.',
    },
  ];

  return (
    <section className={`py-16 lg:py-24 bg-background ${className}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-headline text-primary mb-6">
            Our Culture & Values
          </h2>
          <p className="text-lg text-muted-foreground font-body leading-relaxed">
            We\'ve built a culture that attracts exceptional talent and fosters collaborative excellence. Our values guide how we work with clients, partners, and each other.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {cultureValues.map((value) => (
            <div
              key={value.id}
              className="bg-card rounded-lg p-6 shadow-card hover:shadow-strong transition-all duration-300 border border-border text-center"
            >
              <div className="w-16 h-16 rounded-full bg-secondary/10 flex items-center justify-center mx-auto mb-4">
                <Icon name={value.icon as any} size={32} className="text-secondary" variant="solid" />
              </div>
              <h3 className="text-xl font-bold font-headline text-foreground mb-3">
                {value.title}
              </h3>
              <p className="text-muted-foreground font-body leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CultureSection;